import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  // columns
  id: payload.id,
  name: payload.name,
  email: payload.email,
  phone: payload.phone,
  ext: payload.ext,
  cellphone: payload.cellphone,
  position: payload.position,
  customer_id: payload.customer_id
})
var crud = new Crud('CustomerContacts', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  customerContacts: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions,
  async loadContacts ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`customers/${payload.customerId}/contacts?&page=${payload.page}${state.filterParams}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RECORDS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  }
}

const getters = {
  ...crud.getters,
  customerContacts: state => state.customerContacts
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
